import React from "react"

import TokenList from "decentraland-gatsby/dist/utils/dom/TokenList"

import "./Facebook.css"

export type FacebookProps = React.SVGAttributes<SVGElement>

export const Facebook = React.memo(function (props: FacebookProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="4 4 16 16"
      className={TokenList.join(["icon-facebook", props.className])}
    >
      <path d="M4,5.77777778 C4,4.8 4.8,4 5.77777778,4 L18.2222222,4 C19.2,4 20,4.8 20,5.77777778 L20,18.2222222 C20,19.2 19.2,20 18.2222222,20 L5.77777778,20 C4.8,20 4,19.2 4,18.2222222 L4,5.77777778 Z M15.2,10.8444444 L15.2,9.77777778 C15.2,9.24444444 15.5555556,9.15555556 15.7333333,9.15555556 L17.2444444,9.15555556 L17.2444444,6.84444444 L15.2,6.84444444 C12.8888889,6.84444444 12.3555556,8.53333333 12.3555556,9.6 L12.3555556,10.7555556 L11.1111111,10.7555556 L11.1111111,12.3555556 L11.1111111,13.4222222 L12.4444444,13.4222222 L12.4444444,20 L15.0222222,20 L15.0222222,13.4222222 L16.9777778,13.4222222 L17.0666667,12.3555556 L17.2444444,10.7555556 L15.2,10.7555556 L15.2,10.8444444 Z"></path>
    </svg>
  )
})
